import { environment } from '@environment';

export const USER_ID = 'user_id';
export const LOYALTY_LEVEL = 'loyalty_level';
export const IS_PRIME = 'is_prime';
export const IS_MOBILE = 'is_mobile';

export const homeItemDetailApi = {
  home_flight_offers: `${environment.api.services}/api/ms/travel-alerts/searches/top-n?` +
  'departure={departure}&arrival={arrival}&oneway={oneway}&limit={limit}'
};
